import React, {useState, useEffect} from 'react';
import {Row, Col} from 'reactstrap';
import {Bar, Pie} from 'react-chartjs-2';
import Indicator from '../DataPresenters/Indicator';
import {getDataChart, maskInput, colors} from '../../../utils/utils';
import {MASKS} from '../../../utils/constants';
import Table from '../DataPresenters/Table';

const DashboardFinancials = ({
  table,
  barChart,
  pieChart,
  kpiAccumulated,
  kpiValidated,
  page,
}) => {
  const pageSettings = {
    RECEITAS: {
      mainColor: '#046c00',
      secondaryColor: '#fff',
      labelKpiAccumulated: {
        title: 'Acumulado',
        subtitle: 'Receita',
      },
      labelBarChart: {
        title: 'Receitas do Trimestre',
      },
      labelPieChart: {
        title: 'Receita por Centro de Custos (+5)',
      },
      labelTable: {
        title: 'Receita',
      },
    },
    DESPESAS: {
      mainColor: '#ff0000',
      secondaryColor: '#fff',
      labelKpiAccumulated: {
        title: 'Acumulado',
        subtitle: 'Despesa',
      },
      labelBarChart: {
        title: 'Despesas do Trimestre',
      },
      labelPieChart: {
        title: 'Despesa por Centro de Custos (+5)',
      },
      labelTable: {
        title: 'Despesa',
      },
    },
  };
  const [normalizedBarChartData, setNormalizedBarChartData] = useState(null);
  const [normalizedPieChartData, setNormalizedPieChartData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const dataBarChart = await getDataChart(
        null,
        null,
        barChart,
        false,
        null,
        pageSettings[page].mainColor,
      );

      const formatedDataBarChart = dataBarChart.datasets[0].data.map(
        (number) => number,
      );
      dataBarChart.datasets[0].data = formatedDataBarChart;

      setNormalizedBarChartData(dataBarChart);

      const dataPieChart = await getDataChart(
        null,
        null,
        pieChart,
        null,
        null,
        colors,
      );

      const formatedDataPieChart = dataPieChart.datasets[0].data.map(
        (number) => number,
      );
      dataPieChart.datasets[0].data = formatedDataPieChart;

      setNormalizedPieChartData(dataPieChart);
    };
    if (barChart && barChart.length && pieChart && pieChart.length) {
      loadData();
    }
  }, [barChart]);// eslint-disable-line
  return (
    <div>
      {kpiValidated && (
        <div className="pb-2">
          <Indicator
            multiple
            icon="money-bill"
            iconSize={4}
            color={pageSettings[page].secondaryColor}
            iconSide="right"
            iconValue={kpiValidated.label || ''}
            iconColor={pageSettings[page].secondaryColor}
            iconBackgroundColor={pageSettings[page].mainColor}
            backgroundColor={pageSettings[page].mainColor}
            data={{
              'Valor Validado': `R$ ${maskInput({
                type: MASKS.DOUBLE,
                value: `${Math.round(kpiValidated.validated)}`,
              })}`,
              'Valor não Validado': `R$ ${maskInput({
                type: MASKS.DOUBLE,
                value: `${Math.round(kpiValidated.invalidated)}`,
              })}`,
            }}
          />
        </div>
      )}
      {kpiAccumulated && (
        <Indicator
          icon="money-bill"
          iconSize={4}
          color={pageSettings[page].mainColor}
          iconColor={pageSettings[page].secondaryColor}
          iconBackgroundColor={pageSettings[page].mainColor}
          data={`R$ ${maskInput({
            type: MASKS.DOUBLE,
            value: `${Math.round(kpiAccumulated)}`,
          })}`}
          title={pageSettings[page].labelKpiAccumulated.title}
          subtitle={pageSettings[page].labelKpiAccumulated.subtitle}
        />
      )}
      <Row className="d-flex justify-content-center py-5 page-break">
        {normalizedBarChartData && (
          <Col xs={10} className="cards p-0">
            <h5 className="d-flex flex-column align-items-center">
              {pageSettings[page].labelBarChart.title}
            </h5>
            <Bar
              responsive
              label={pageSettings[page].labelBarChart.title}
              data={normalizedBarChartData}
              options={{
                plugins: {
                  datalabels: {
                    labels: {
                      title: {
                        font: {
                          size: 16,
                        },
                      },
                    },
                    anchor: (val) => {
                      if (val.dataset.data[val.dataIndex] >= 0) {
                        return 'end';
                      }
                      return 'start';
                    },
                    align: (val) => {
                      if (val.dataset.data[val.dataIndex] >= 0) {
                        return 'top';
                      }
                      return 'bottom';
                    },
                    formatter: (value) => {
                      return `R$ ${maskInput({
                        type: MASKS.DOUBLE,
                        value: `${value}`,
                      })}`;
                    },
                  },
                },
                layout: {
                  padding: {
                    left: 0,
                    right: 0,
                    top: 40,
                    bottom: 0,
                  },
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return `R$ ${maskInput({
                        type: MASKS.DOUBLE,
                        value: `${data.datasets[0].data[tooltipItem.index]}`,
                      })}`;
                    },
                  },
                },
                scales: {
                  xAxes: [
                    {
                      ticks: {
                        fontSize: 16,
                      },
                      gridLines: {
                        color: 'rgba(0, 0, 0, 0)',
                        display: false,
                      },
                    },
                  ],
                  yAxes: [
                    {
                      gridLines: {
                        color: 'rgba(0, 0, 0, 0)',
                      },
                      ticks: {
                        display: false,
                        // Create scientific notation labels
                        callback: (value) => {
                          return `R$ ${maskInput({
                            type: MASKS.DOUBLE,
                            value: `${value}`,
                          })}`;
                        },
                      },
                    },
                  ],
                },
              }}
            />
          </Col>
        )}
      </Row>
      <Row className="d-flex justify-content-center py-5 page-break">
        {normalizedPieChartData && (
          <Col xs={10}>
            <h5 className="d-flex flex-column align-items-center">
              {pageSettings[page].labelPieChart.title}
            </h5>
            <Pie
              responsive
              data={normalizedPieChartData}
              width={window.innerWidth < 767 ? '100%' : null}
              options={{
                legend: {
                  labels: {
                    fontSize: 16,
                  },
                },
                plugins: {
                  datalabels: {
                    display: false,
                  },
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return `R$ ${maskInput({
                        type: MASKS.DOUBLE,
                        value: `${data.datasets[0].data[tooltipItem.index]}`,
                      })}`;
                    },
                  },
                },
                pieceLabel: [
                  {
                    render: 'label',
                    fontColor: '#000',
                    position: 'outside',
                    fontSize: 16,
                    arc: false,
                  },
                  {
                    render: (args) => {
                      return `R$ ${maskInput({
                        type: MASKS.DOUBLE,
                        value: `${args.value}`,
                      })}`;
                    },
                    fontSize: 16,
                    fontColor: '#000',
                  },
                ],
              }}
            />
          </Col>
        )}
      </Row>
      {table && (
        <Table
          title={`${pageSettings[page].labelTable.title} - Mês`}
          columns={[
            {key: 'label', name: 'Mês/Ano'},
            {key: 'data', name: pageSettings[page].labelTable.title},
          ]}
          formatter={(value, column) => {
            if (column === 'data') {
              return `R$ ${maskInput({
                type: MASKS.DOUBLE,
                value: `${Math.round(value)}`,
              })}`;
            }

            return value;
          }}
          rows={table}
          gridTemplate="repeat(2, 1fr)"
        />
      )}
    </div>
  );
};

export default DashboardFinancials;
